// Who clients write to about the dashboard, until account managers are listed
// per company.
export const DASHBOARD_CONTACT = "james.atherton@walkingonearth.com";

// The account manager the Business impact page names, until account managers
// are listed per company.
export const ACCOUNT_MANAGER = {
  name: "James Atherton",
  initials: "JA",
  email: "james.atherton@walkingonearth.com",
};
